module.exports = "<p class=\"pull-right\">\r\n  main-menu works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/main-menu/main-menu.component.html
// module id = ./src/app/components/framework/main-menu/main-menu.component.html
// module chunks = main